import { Decimal } from 'decimal.js';
import { unFormatCurrency, unFormatPercent } from 'utils';

const isTimeHorizon = (value: number) =>
  value && (value < 3 || value > 75)
    ? 'Time horizon should be a number between 3-75'
    : undefined;

const required = (value: any) => {
  return value || typeof value === 'number' ? undefined : 'Required';
};
const riskProfileRequired = (value: any) => {
  return value || typeof value === 'number'
    ? undefined
    : 'Please note, a recommended risk profile must be selected before proceeding further';
};

const isPercentageValid = (value: number) => {
  if (!value) return undefined;
  return unFormatPercent(value) >= 0 && unFormatPercent(value) <= 100
    ? undefined
    : 'Please provide value between 0-100';
};

const isExceedTransferValue = (totalTransferValue: any) => (value: any) => {
  if (!value) return undefined;
  return Number(unFormatCurrency(value)) > Number(totalTransferValue)
    ? 'Provided value exceeded total transfer value'
    : undefined;
};

const max3Decimals = (val: any) => {
  if (!val) return undefined;

  const decimalNumber = new Decimal(val);
  const numberOfDecimals = decimalNumber.dp();

  return numberOfDecimals > 3
    ? 'Ensure that there are no more than 3 decimal places.'
    : undefined;
};

const moreThanZero = (val: any) => {
  return Number(val) <= 0 ? 'Value should be greater than 0' : undefined;
};

const isChargeExceedMaxChargeValue = (maxValue: number) => (val: any) => {
  if (!val) return undefined;
  return Number(unFormatCurrency(val)) > Number(maxValue)
    ? 'Provided Charge exceeded fund value'
    : undefined;
};

const isChargeExceedMaxPercentChargeValue =
  (maxValue: number) => (val: any) => {
    if (!val) return undefined;
    return Number(unFormatPercent(val)) > Number(maxValue)
      ? 'Provided Charge exceeded fund value'
      : undefined;
  };

const maxDecimals = (max: number) => (val: string) => {
  if (!val) return undefined;
  const decimalNumber = new Decimal(val);
  const numberOfDecimals = decimalNumber.dp();

  return numberOfDecimals > max
    ? `Ensure that there are no more than ${max} decimal places.`
    : undefined;
};

const isExceededUnnalocatedMoney =
  (unnalocatedMoney: number) => (amount: string) => {
    if (!amount) return undefined;
    return Number(unFormatCurrency(amount)) >
      Number(unFormatCurrency(unnalocatedMoney))
      ? 'Not enough unallocated contributions amount'
      : undefined;
  };

const isChargePercentageValid = (value: string) => {
  if (!value) return undefined;
  if (value === '-') return undefined;
  return Number(unFormatPercent(value)) >= 0 &&
    Number(unFormatPercent(value)) <= 100
    ? undefined
    : 'Please provide value between 0-100';
};

const isGreaterThanZero = (value: string) => {
  if (!value) return undefined;
  return Number(unFormatCurrency(value)) > 0
    ? undefined
    : 'Please provide value grater than 0';
};

const isValidEmail = (value: string) => {
  if (!value) return undefined;
  /* eslint-disable no-control-regex */
  const regex =
    /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
  /* eslint-enable no-control-regex */
  return regex.test(value) ? undefined : 'Please provide a valid email address';
};

export default {
  isTimeHorizon,
  required,
  isPercentageValid,
  isExceedTransferValue,
  max3Decimals,
  moreThanZero,
  isChargeExceedMaxChargeValue,
  isChargeExceedMaxPercentChargeValue,
  maxDecimals,
  isExceededUnnalocatedMoney,
  isChargePercentageValid,
  isGreaterThanZero,
  riskProfileRequired,
  isValidEmail
};
